import { message } from 'antd'
import { sendProjectInformationEmail } from '../../../HttpRequests/projects';
import { setFileList } from '../State/fileList';
import handleException from '../../../Core/Helpers/handleException';

export default (values) => async (dispatch, getState) => {

  try {

    const { id } = values;

    const data = new FormData();

    data.append('to', values.to.join(','));
    data.append('cc', values.cc.join(','));
    data.append('bcc', values.bcc.join(','));
    data.append('subject', values.subject);
    data.append('body', values.body);
    data.append('type', values.type);
    data.append('projectFiles', values.projectFiles);

    values.projectFiles.forEach((path) => {
      data.append('projectFiles[]', path);
    });

    const { fileList } = getState().modals.EmailProjectInformation;

    fileList.forEach((file) => {
      data.append('files[]', file);
    });

    await sendProjectInformationEmail({ id, data });

    message.success("Mail Queued");

    dispatch(setFileList([]));

    return true;

  } catch(error) {

    handleException(error);

    return false;
  }
}
